const AllocationEntity = (client) => ({
  allocate: async (id, type) =>
    await client.post(`/api/collect/${type}/${id}/allocate`),
})

export default AllocationEntity
